import React from 'react'

export default function Card(props) {
  return(
<>
<div className='parent-div'>
<section className="portfolio-section" id="portfolio">
   
    <div className="portfolio--grid-container"/>
      <div className="portfolio-grid" id="grid1">
        <figure className="project-fig">
          <img className='project-img' src={props.sourceimg} alt="" />
          {/*  */}
          <figcaption>{props.caption}</figcaption>
        </figure>
        {/* Recipe Blog */}
        <h3>{props.title}</h3>
        {/*  */}
        <p id='text-para'>
        {props.description}
          
        </p>
        <div className="buttons">
          <button className="demo-btn btn">
            <a href={props.demolink}
      target="_blank" rel="noopener noreferrer"
              >Demo</a
            >
          </button>
          <button className="code-btn btn">
            <a
             href={props.codelink}
             
               target="_blank" rel="noopener noreferrer"
             
              >Code</a
            >
          </button>
        </div>
    
        
        </div>
        </section>
    
        </div>
        </>

  )
  
  
}